
//import { useState } from 'react';

import List from '@mui/joy/List';

import { observer } from 'mobx-react-lite';
import IconLink from 'components/IconLink';
import useAuth from 'hooks/useAuth';
// import useRoles from 'hooks/useRoles';
import useUserIdentity from 'hooks/useUserIdentity';

function SidebarClient() {

    // const { hasRole } = useRoles();
    const { currentIdentity } = useUserIdentity();
    const { currentUser } = useAuth();


    return (
        <>
            <List
                sx={{
                    '--ListItem-radius': '8px',
                    '--List-gap': '4px',
                    // '--List-padding': '8px',
                    '--List-nestedInsetStart': '40px',
                }}
            >
                <IconLink
                    url="/requests"
                    icon="FormatListBulletedOutlined"
                    title="Requests" />
                <IconLink
                    url="/calendar"
                    icon="CalendarMonthOutlined"
                    tooltip="View your calendar"
                    title="Calendar" />
                {currentUser.subscription_product == 'dedicated' &&
                    <IconLink
                        url={`/identity/${currentIdentity.uuid}/clock-report`}
                        icon="DayOnesReport"
                        tooltip="View your usage report"
                        title="Usage" />}

            </List>
        </>
    );
}

const cp = observer(SidebarClient);
export default cp;
